import {
  Group,
  // Box3, 
  Vector3,
} from "three";

import { Segment } from './segment.js';
// import { size as BrickSize } from './brick.js';

class Stage {

  constructor( json ) {

    const voxel = ( window.CONFIG && window.CONFIG.brick ) ? window.CONFIG.brick.voxel :  16;
    const chunk = ( window.CONFIG && window.CONFIG.road ) ? window.CONFIG.road.chunk :  3; // number of bricks in a row
    const rows = ( window.CONFIG && window.CONFIG.road ) ? window.CONFIG.road.rows :  3; // BUG: number of rows in segment of road (NEEDS TO BE EVEN FOR NOW - BUG IN THE ROW OFFSET!!!!!)
    //const segmentMax = ( window.CONFIG && window.CONFIG.road ) ? window.CONFIG.road.segments :  3; // number of segments of road (overwrtiting JSON length for now )

    /* SETUP */
    const stage = new Group();
    stage.segments = new Array(); // collection of segments to manage lazy loading, gravity and raycaster performance wise
    stage.currentSegment = null; // keeping track where we are
    stage.moving = false; // is the road moving?

    //stage.chunks = new Array(); // collection for raycaster / gravity
    // stage.bricks = new Array(); // collection for raycaster / gravity
    //stage.objects = new Array(); // so we can toggle them on/off

    // NEW: BETTER ARRAY FOR RAYCASTER/GRAVITY
    //stage.targets = new Array(); // raycaster targets per segment only please!
    //stage.actors = new Array(); // gravity targets per segment only please!

    /* SEGMENTS */

    let segments = Math.ceil(json.length / (rows*chunk) ); //Math.min( Math.ceil(json.length / (rows*chunk) ), segmentMax); // number of segments to make a road
    let z = 0;
    stage.bricks = 0;
    stage.props = 0;

    for (let si = 0; si < segments; si++) {
      const data = json.slice( si*(rows*chunk), (si+1)*(rows*chunk) ); // segment data only
      // console.log( '**', si, data.length, data[0], data[data.length-1])
      const segment = new Segment( si, data, chunk, rows );
      segment.position.set(0, 0, z);
      stage.add(segment);
      // stage.bricks = stage.bricks.concat(segment.bricks);
      //stage.targets.push( segment.bricks );
      //stage.actors.push( segment.chunks.concat(segment.props) );

      // stage.chunks = stage.chunks.concat(segment.chunks);
      //stage.actors = stage.actors.concat(segment.actors);

      stage.segments.push( segment );

      z -= rows * voxel;
      stage.bricks  += segment.bricks;
      stage.props  += segment.props;
      //z -= voxel // to debug segments parts
    }

    // /*
    //   TEMP GLOW CODE
    //   TODO: need to move this to it's own file !!!    
    //   idea from view-source:http://stemkoski.github.io/Three.js/Shader-Halo.html
    // */

    // // create custom material from the shader code above
    // // that is within specially labeled script tags
    // var customMaterial = new ShaderMaterial( 
    // {
    //     uniforms: {  },
    //   vertexShader:   document.getElementById( 'vertexShader'   ).textContent,
    //   fragmentShader: document.getElementById( 'fragmentShader' ).textContent,
    //   side: BackSide,
    //   blending: AdditiveBlending,
    //   transparent: true
    // }   );
      
    // var brick = new BoxBufferGeometry( voxel*2, voxel, voxel, 1, 1, 1 );
    // var glowBrick = new Mesh( brick, customMaterial );


    //new Box3().setFromObject( stage ).getCenter( stage.position ).multiplyScalar( - 1 );
    const point = new Vector3();
    
    /*
    const box3 = new Box3().setFromObject(stage);
    box3.getCenter(point);
    stage.position.x = -point.x; // Only center x for now!!
    */

    stage.position.x -= (voxel*2) * 1.25; // this is center of the road if rows have 3 bricks
    point.copy( stage.position );
    stage.orignalPosition = point;

    /* activeObjects: using currentSegment index we can get only active objects */
    stage.activeObjects = ( type )=>{
      /**
       * TODO:
       * - improve this concat code
       * - cache the object
      */
      let objects = [];
      if( stage.segments[stage.currentSegment-1] ) objects = objects.concat( stage.segments[stage.currentSegment-1][type] );
      if( stage.segments[stage.currentSegment] ) objects = objects.concat( stage.segments[stage.currentSegment][type] );
      if( stage.segments[stage.currentSegment+1] ) objects = objects.concat( stage.segments[stage.currentSegment+1][type] );
      return objects;
    };

    /* show: show/hide segments based on current row */
    stage.show = ( row )=>{
      const si = Math.floor( row / rows );
      if( si == stage.currentSegment ) return null;
      stage.currentSegment = si;
      stage.segments.forEach(segment => {
        const show = ( segment.index >= stage.currentSegment-1 && segment.index <= stage.currentSegment+1 ) ? true : false;
        if( show && !segment.updated ) segment.update(); // if any lazy loading updates needed
        segment.visible = show;
      });
    }

    stage.toggleProps = ( show )=>{
      stage.segments.forEach(segment => {
        segment.actors.forEach( actor => {
          if( actor.name != 'row' ) actor.visible = show;
        })
      });
    }

    /* moveTo: move to a brick based on an brick index */
    stage.moveTo = ( brick )=>{ 
      const row = Math.floor( brick / chunk);
      //console.log( 'moveTo', brick, row );
      stage.show( row );
      stage.position.z = row * voxel;
      stage.position.z += voxel;//?!
    }

    /* move: move entire road based on direction */
    // const max = Math.ceil( segments * rows ) * voxel;
    const max = stage.bricks/chunk  * voxel;
    
    // console.log( max, (stage.bricks/chunk) * voxel );
    stage.move = ( delta, amount = 100 )=>{
      let z = stage.position.z;
      z += amount*delta;
      if( z > stage.orignalPosition.z + voxel && z < max  ){
        const row = Math.floor( ( z + voxel/2 ) / voxel );
        stage.show( row );
        stage.position.z = z;
        stage.moving = true
      }else{
        stage.moving = false;
      }
    }

    return stage;
  }
}

export { Stage };